import React, { useEffect, useState } from "react";

export const ZOOM_HINT_STATE = {
  idle: "idle",
  shown: "shown",
  passed: "passed",
}


export const useZoomHint = (mapElementName: string) => {
    const [zoomHint, setZoomHint] = useState(ZOOM_HINT_STATE.idle)
    
  
    const handleZoomHintShowing = () => {      
      // Show the hint
        setZoomHint(ZOOM_HINT_STATE.shown);
  
        // Hide the hint after 2 seconds
        setTimeout(() => {
          setZoomHint(ZOOM_HINT_STATE.passed);
        }, 2000);
      }  

      useEffect(() => {
        if (zoomHint !== ZOOM_HINT_STATE.idle) return;
        const mapElement = document.getElementById(mapElementName);
        if (!mapElement) return;
        
        mapElement.addEventListener('wheel', handleZoomHintShowing);
        mapElement.addEventListener('touchstart', handleZoomHintShowing);

    
        return () => {
          mapElement.removeEventListener('wheel', handleZoomHintShowing);
          mapElement.removeEventListener('touchstart', handleZoomHintShowing);
        }
    


      }, [zoomHint])

      return zoomHint
    
}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useZoomHint.ts